<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          display: flex;
          align-items: center;
          padding: 10px 20px;
        "
      >
        <li style="font-size: 13px">扣缴义务人详情</li>
        <li style="flex: 1; text-align: center; font-weight: 600">
          {{ state.model?.name }}
        </li>
        <li>
          <el-button
            type="primary"
            link
            icon="Edit"
            @click="state.showEdit = true"
            v-if="$judge_auth('65')"
          >
            编辑信息
          </el-button>
        </li>
      </ul>
      <el-descriptions
        :column="4"
        border
        style="margin: 10px"
        class="desc-label-nowrap"
        size="large"
      >
        <el-descriptions-item label="状态" label-align="right">
          <div
            style="width: 300px"
            :style="{ color: state.model.status == 1 ? '#1e90ff' : '#f00' }"
          >
            {{ state.model.status == 1 ? "正常" : "停用" }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="企业名称" label-align="right">
          <div style="width: 300px">
            {{ state.model.name }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="统一社会信用代码" label-align="right">
          <div style="width: 300px">
             <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click="$onCopy(state.model.unified_social_credit_identifier)"
            >
              {{ state.model.unified_social_credit_identifier }}
            </text>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="所属行业" label-align="right">
          <div style="width: 300px">
            {{ state.model.d_industry_name }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="银行户名" label-align="right">
          <div style="width: 300px">
            {{ state.model.bank_account_name }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="开户行" label-align="right">
          <div style="width: 300px">
            {{ state.model.opening_bank }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="银行账号" label-align="right">
          <div style="width: 300px">
            {{ state.model.bank_account }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="是否对接银企" label-align="right">
          <div
            style="width: 300px"
            :style="{
              color: state.model.is_interface == 1 ? '#1e90ff' : '#f00',
            }"
          >
            {{ state.model.status == 1 ? "是" : "否" }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="实名登录账号" label-align="right">
          <div style="width: 300px">
            {{ state.model.declare_password }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="所属地区" label-align="right">
          <div style="width: 300px">
            {{ state.model.area || "-" }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="所在地址" label-align="right" :span="2">
          {{ state.model.address || "-" }}
        </el-descriptions-item>
      </el-descriptions>
      <ul
        style="
          flex: 1;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        "
      >
        <el-tabs
          v-model="state.activeName"
          class="detail-tabs"
          style="
            display: flex;
            flex-direction: column;
            overflow: hidden;
            flex: 1;
          "
        >
          <el-tab-pane label="付款银行账户" name="fkyh">
            <c_bank
              :withholding_agent_id="props.data?.id"
              v-if="state.activeName == 'fkyh'"
            ></c_bank>
          </el-tab-pane>
        </el-tabs>
      </ul>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdit"
      title="编辑扣缴义务人"
      @close="state.showEdit = false"
    >
      <c_WithholdingAgentInfo
        @close="
          state.showEdit = false;
          onLoad();
        "
        :id="props.data?.id"
      ></c_WithholdingAgentInfo>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { withholdingagent_detail } from "@/http/withholdingagent";

import c_bank from "./Detail/BankAccountPay/List.vue";
export default {
  components: {
    c_bank,
  },
  props: {
    data: Object,
  },
  setup(props) {
    const state = reactive({
      model: {},
      activeName: "fkyh",
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      withholdingagent_detail(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    };
    return { state, props, onLoad };
  },
};
</script>
<style scoped lang="less">
.cus-desc {
  & > div {
    width: 25%;
  }
}
</style>
